export const processingStatus = {
  Processing: 1,
  Processed: 2,
  Failed: 3
}

export const ProcessingStatusName = {
  [processingStatus.Processing]: 'Processing',
  [processingStatus.Processed]: 'Processed',
  [processingStatus.Failed]: 'Failed'
}
